<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="successMessage.showSuccessMessage">
                    {{successMessage.message}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errorMessage.showErrorMessage">
                    {{errorMessage.message}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="validateFuelDispensement" v-if="!successMessage.showSuccessMessage && !errorMessage.showErrorMessage">
                    <div class="form-group">
                        <label for="orderNumberInput">
                            Collection Code
                        </label>
                        <div class="text-danger" v-if="orderInfoToValidation.orderNumber.hasError">
                            {{ orderInfoToValidation.orderNumber.errorMessage}}
                        </div>
                        <input type="text" placeholder="Collection Code" class="form-control" id="orderNumberInput" v-model="orderInfoToValidation.orderNumber.value">
                    </div>
                    <div class="form-group">
                        <label for="vehicleRegistrationInput">
                            Vehicle Registration
                        </label>
                        <div class="text-danger" v-if="orderInfoToValidation.vehicleRegistration.hasError">
                            {{ orderInfoToValidation.vehicleRegistration.errorMessage}}
                        </div>
                        <input type="text" class="form-control" placeholder="Vehicle Registration" id="vehicleRegistrationInput" v-model="orderInfoToValidation.vehicleRegistration.value">
                    </div>
                    <button class="btn btn-primary mr-2" :disabled="loading">Validate</button>
                </form>
            </div>
        </div>
    </div>
</div>
